import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/app/startup/$id/profile/links')({
  component: () => null,
})
